// В.2.e-1: Правая рука Лизы (liv_pravaya_ruka_lizy, epic, 3/0/4).
// Приказ при выставлении: «Полностью исцеляет всех союзных юнитов».
//
// Эффект:
//   - Цель — все живые союзные ЮНИТЫ на поле, включая саму Правую руку
//     (она только что выставлена с полным ХП → actualAmount=0, событие
//     healed не эмитится — это норма).
//   - НЕ лечит Героя.
//   - НЕ лечит вражеских юнитов.
//   - Лечение через healUnit(unit, max - cur, source=cardId) — триггерит
//     событие healed для каждого вылеченного (Ошибка эксперимента +1 atk
//     за реальный хил).
//   - Молчание Правой руки на момент срабатывания блокирует Приказ
//     (стандартное правило).
//
// Picker не нужен — нет выбора цели.

import { registerImplementedAbility } from './warn-unimplemented.js';
import { healUnit } from './heal.js';

export const CARD_ID = 'liv_pravaya_ruka_lizy';
const LABEL = 'Правая рука Лизы';

registerImplementedAbility(CARD_ID, 'order');

export function pravayaRukaLizyOrder(state, ownerIdx, ruka /*, opts */) {
  if (!ruka || !ruka.isAlive()) return;
  if (ruka.current?.silenced) return;
  const me = state.players?.[ownerIdx];
  if (!me) return;
  state.log?.add(`📋 ${LABEL} [${me.name}]: полное исцеление всех союзных юнитов`);
  // Снимок — лечим только тех, кто на поле сейчас. Если кто-то умрёт
  // в процессе лечения (нет такой механики, но защитимся) — не падаем.
  const allies = me.unitsOnField().filter(u => u.type === 'unit' && u.isAlive());
  for (const ally of allies) {
    const max = ally.base?.hp ?? 0;
    const cur = ally.current?.hp ?? 0;
    const need = Math.max(0, max - cur);
    if (need <= 0) continue;
    healUnit(state, ally, need, ruka);
  }
}
